import dynamic from 'next/dynamic';

import { CopyBlockSectionProps } from '../../../components/sections/CopyBlockSection';
import { SectionRenderer } from '../../../types/Section';
import { Transformer } from '../../../types/Transformer';
import { CopyBlockContentSection } from './types';

/* istanbul ignore next */
export const renderer: SectionRenderer<CopyBlockSectionProps> = dynamic<CopyBlockSectionProps>(() =>
  import('../../../components/sections/CopyBlockSection').then((mod) => mod.CopyBlockSection),
);

export const transformer: Transformer<CopyBlockContentSection, CopyBlockSectionProps> = ({
  _metadata,
  copy,
  alignment,
  tracking_title,
}) => ({
  uid: _metadata.uid,
  props: {
    children: copy,
    alignment,
    trackingTitle: tracking_title,
  },
});
